import styled from 'styled-components';
import { color } from '@m/alchemy-ui/theme';

export const List = styled.ul<{ $mobilePreviewMode?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  padding: 0;
  overflow: visible;
  margin: 8px 8px 0;

  ${(props) =>
    props.$mobilePreviewMode &&
    `
    max-width: 100%;
  `}

  @media (max-width: 760px) {
    max-width: 100%;
  }
`;

export const ListItem = styled.li<{ $panelSize: number; $hasWideSibling: boolean; $mobilePreviewMode?: boolean }>`
  display: flex;
  flex: 1 1 300px;
  align-content: flex-start;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin: 8px 0 0 0;
  min-height: 68px;
  max-height: 100px;
  ${(props) => (props.$panelSize === 1 && !props.$hasWideSibling ? `max-width: 33%; min-width: 33%;` : '')}
  ${(props) => (props.$panelSize === 2 && !props.$hasWideSibling ? `max-width: 50%;` : '')}
  ${(props) => (props.$panelSize === 3 || props.$hasWideSibling ? `max-width: 100%;` : '')};

  ${(props) =>
    props.$mobilePreviewMode &&
    `
    max-width: 100%;
  `}

  @media (max-width: 760px) {
    max-width: 100%;
  }
`;

export const ItemText = styled.div`
  flex: 1;
  max-width: 100%;
  margin-left: 10px;
  margin-right: 10px;
`;

export const Avatar = styled.img<{ $size?: number }>`
  display: flex;
  border-radius: 50%;
  min-width: ${({ $size }) => $size ?? 36}px;
  min-height: ${({ $size }) => $size ?? 36}px;
  max-width: ${({ $size }) => $size ?? 36}px;
  max-height: ${({ $size }) => $size ?? 36}px;
  margin-right: 10px;
  opacity: 0.8;
  &:hover {
    opacity: 1;
    animation-duration: 0.1s;
  }
`;

export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #eaf3ff;
  border: 1px solid #b9dfff;
  width: 100%;
`;

export const Meta = styled.div`
  display: flex;
  display: block;
  gap: 5px;
  margin-top: 2px;
  font-size: 11px;
  line-height: 16px;
  color: #4e4e4e;
`;

export const UserDialogButton = styled.button`
  display: inline !important;
  padding: 0 !important;
  margin: 0 !important;
  color: ${color('typeLink')} !important;
  text-decoration: none !important;
  line-height: 1.4 !important;
  background: transparent !important;
  border: transparent !important;
  text-align: left !important;
`;

export const TextLink = styled.a`
  text-decoration: underline;
  color: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
  &:focus,
  &:visited {
    text-decoration: underline;
  }
`;

export const MutedText = styled.span`
  display: inline;
  color: ${color('a11yBase', { palette: 'illustrativeSteelGrey' })};
`;
